// extracted by mini-css-extract-plugin
module.exports = {"outer":"_8ssYh","padding":"_2RA2F","heading":"_1-vUl","link":"_3Xlpb","inputBox":"_1zmiE","text":"_2uiZy","twitter":"_1UB6N","facebook":"ja0hH"};